module.exports = __webpack_public_path__ + "img/ej-01.fafdeb3a.png";